import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './runtime-var';

import './dis-debugger';
import '../logger/arms-config';
import '../logger/bd-tracker';
import '../network/axios-init';
import '../../styles/global.less';
// import reportWebVitals from './reportWebVitals';

import '../../locales/init';

import '../network/axios-helper';


console.log('[PageTest]页面前置业务逻辑初始化完成');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
